import { createGtmEvent } from "@/client/gtm/gtm";

function addUserDataGtmEvent(userData: {
  customerId?: number | null;
  userId: number;
}) {
  return createGtmEvent("user_data", userData);
}

export { addUserDataGtmEvent };
